module.exports = __webpack_public_path__ + "media/images/lb/412-1a90d19de1a3f853c1149d86bf71a28b.svg";